module.exports = __webpack_public_path__ + "img/ssb_menu19.26e480ed.png";